import ChatProvider from '../store/schema/ChatProvider';
import type StartChatSource from '../store/schema/StartChatSource';
import { default as startUcmaChat } from '../ucma/chatManager/startChat';
import { default as startUcwaChat } from '../ucwa/chatManager/startChat';
import { getStore } from '../store/chatStore';

export default function startChat(
    sipUris: string[],
    subject: string,
    source: StartChatSource
): boolean {
    switch (getStore().chatProvider) {
        case ChatProvider.UCMA:
            return startUcmaChat(sipUris, subject, source);
        case ChatProvider.UCWA:
            return startUcwaChat(sipUris, subject, source);
    }
    return false;
}
